import { render, staticRenderFns } from "./ddcf.vue?vue&type=template&id=bb9b919a&scoped=true&"
import script from "./ddcf.vue?vue&type=script&lang=js&"
export * from "./ddcf.vue?vue&type=script&lang=js&"
import style0 from "./ddcf.vue?vue&type=style&index=0&id=bb9b919a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b919a",
  null
  
)

export default component.exports